import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-extrabold">Nothing here</h1>
      <Link to="/">Go home</Link>
    </div>
  );
}
